var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticStyle:{"font-size":"18px","line-height":"1.8em"}},[_vm._v("\n    "+_vm._s(_vm.getPos)+"\n  ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.del}},[_vm._v("删除")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5038a2d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/MarkerPopup.vue
// module id = null
// module chunks = 